import { GoogleMap, InfoWindow, Marker, withGoogleMap, withScriptjs } from 'react-google-maps';
import React, { PureComponent } from 'react';

import Geocode from 'react-geocode';
import Map from './Map';

const geocodeJson = 'https://maps.googleapis.com/maps/api/geocode/json';
Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAPS_API_KEY);
Geocode.enableDebug();
class MapFunctional extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			address: '',
			city: '',
			area: '',
			state: '',
			lmg: '',
			rmg: '',
			mapPosition: {
				lat: this.props.center.lat,
				lng: this.props.center.lng,
			},
			markerPosition: {
				lat: this.props.center.lat,
				lng: this.props.center.lng,
			},
		};
		this.getMyLocation = this.getMyLocation.bind(this);
	}
	componentDidMount() {
		Geocode.fromLatLng(this.state.mapPosition.lat, this.state.mapPosition.lng).then(
			(response) => {
				const address = response.results[0].formatted_address,
					addressArray = response.results[0].address_components,
					city = this.getCity(addressArray),
					area = this.getArea(addressArray),
					state = this.getState(addressArray);
				this.setState({
					address: address ? address : '',
					area: area ? area : '',
					city: city ? city : '',
					state: state ? state : '',
				});
			},
			(error) => {
				console.error(error);
			}
		);
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (
			this.state.markerPosition.lat !== this.props.center.lat ||
			this.state.address !== nextState.address ||
			this.state.city !== nextState.city ||
			this.state.area !== nextState.area ||
			this.state.state !== nextState.state
		) {
			return true;
		} else if (this.props.center.lat === nextProps.center.lat) {
			return false;
		}
	}

	getCity = (addressArray) => {
		let city = '';
		for (let i = 0; i < addressArray.length; i++) {
			if (addressArray[i].types[0] && 'administrative_area_level_2' === addressArray[i].types[0]) {
				city = addressArray[i].long_name;
				return city;
			}
		}
	};

	getArea = (addressArray) => {
		let area = '';
		for (let i = 0; i < addressArray.length; i++) {
			if (addressArray[i].types[0]) {
				for (let j = 0; j < addressArray[i].types.length; j++) {
					if ('sublocality_level_1' === addressArray[i].types[j] || 'locality' === addressArray[i].types[j]) {
						area = addressArray[i].long_name;
						this.setState({ area: area });
						return area;
					}
				}
			}
		}
	};

	getLandmark = (addressArray) => {
		let area = '';
		for (let i = 0; i < addressArray.length; i++) {
			if (addressArray[i].types[0]) {
				for (let j = 0; j < addressArray[i].types.length; j++) {
					if ('sublocality_level_1' === addressArray[i].types[j] || 'landmark' === addressArray[i].types[j]) {
						area = addressArray[i].long_name;
						return area;
					}
				}
			}
		}
	};

	getState = (addressArray) => {
		let state = '';
		for (let i = 0; i < addressArray.length; i++) {
			for (let i = 0; i < addressArray.length; i++) {
				if (addressArray[i].types[0] && 'administrative_area_level_1' === addressArray[i].types[0]) {
					state = addressArray[i].long_name;
					return state;
				}
			}
		}
	};

	onChange = (event) => {
		this.setState({ [event.target.name]: event.target.value });
	};

	onInfoWindowClose = (event) => { };

	onMarkerDragEnd = (event) => {
		let newLat = event.latLng.lat(),
			newLng = event.latLng.lng();

		Geocode.fromLatLng(newLat, newLng).then(
			(response) => {
				const address = response.results[0].formatted_address,
					addressArray = response.results[0].address_components,
					city = this.getCity(addressArray),
					area = this.getArea(addressArray),
					state = this.getState(addressArray);
				this.setState({
					address: address ? address : '',
					area: area ? area : '',
					city: city ? city : '',
					state: state ? state : '',
					markerPosition: {
						lat: newLat,
						lng: newLng,
					},
					// mapPosition: {
					// 	lat: newLat,
					// 	lng: newLng,
					// },
				});
			},
			(error) => {
				console.error(error);
			}
		);
	};
	onPlaceSelected = (place) => {
		try {
			let phoneNumber = place.formatted_phone_number;
			let name = place.name;
			let address = place.formatted_address,
				addressArray = place.address_components,
				city = this.getCity(addressArray),
				area = this.getArea(addressArray),
				state = this.getState(addressArray),
				latValue = place.geometry.location.lat(),
				lngValue = place.geometry.location.lng();

			let landmark = this.getLandmark(addressArray);

			// Set these values in the state.

			console.log('lol', city, area, state, landmark, phoneNumber);
			this.setState({
				address: address ? address : '',
				area: area ? area : '',
				city: city ? city : '',
				state: state ? state : '',
				markerPosition: {
					lat: latValue,
					lng: lngValue,
				},
				mapPosition: {
					lat: latValue,
					lng: lngValue,
				},
			});
			this.props.getLatLngFromSelected(latValue, lngValue);
			this.props.setValuesForAddressForm({ area, phoneNumber, name });
		} catch (error) {
			console.log(error);
		}
	};

	reverseGeocode = ({ latitude: lat, longitude: lng }) => {
		const url = `${geocodeJson}?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&latlng=${lat},${lng}`;
		fetch(url)
			.then((response) => response.json())
			.then((location) => {
				// const place = location.results[0];
				// const _address = extractAddress(place);
				// setAddress(_address);
				// searchInput.current.value = _address.plain();
			});
	};
	async getMyLocation() {
		Geocode.setLocationType('ROOFTOP');
		let lat = null;
		let lng = null;
		const location = window.navigator && window.navigator.geolocation;
		if (location) {
			location.getCurrentPosition(
				(position) => {
					lat = position.coords.latitude;
					lat = position.coords.longitude;
					this.reverseGeocode(position.coords);
					// Geocode.fromLatLng(position.coords.latitude, position.coords.longitude)
					// 	.then((res) => {
					// 		console.log('re33324', res);
					// 	})
					// 	.catch((error) => {
					// 		console.log('geoerror', error);
					// 	});
					this.setState({
						mapPosition: {
							lat: position.coords.latitude,
							lng: position.coords.longitude,
						},
						markerPosition: {
							lat: position.coords.latitude,
							lng: position.coords.longitude,
						},
					});
				},
				(error) => {
					console.log(error);
					this.setState({ latitude: 'err-latitude', longitude: 'err-longitude' });
				}
			);
			console.log('#########', lat, lng);
		}
		console.log('mapPosition', this.state.mapPosition);
		console.log('this.props.google', this.props.google);
	}

	render() {
		return (
			<Map
				onPlaceSelected={this.onPlaceSelected}
				onMarkerDragEnd={this.onMarkerDragEnd}
				onChange={this.onChange}
				getCity={this.getCity}
				getArea={this.getArea}
				getState={this.getState}
				lat={this.props.center.lat}
				lng={this.props.center.lng}
				getMyLocation={this.getMyLocation}
				mapPosition={this.state.mapPosition}
				markerPosition={this.state.markerPosition}
				address={this.state.address}
				google={this.props.google}
				zoom={this.props.zoom}
				height={this.props.height}
				area={this.state.area}
			/>
		);
	}
}
export default MapFunctional;
